import { render, staticRenderFns } from "./admperformReport.vue?vue&type=template&id=190fe51b"
import script from "./admperformReport.vue?vue&type=script&lang=js"
export * from "./admperformReport.vue?vue&type=script&lang=js"
import style0 from "./admperformReport.vue?vue&type=style&index=0&id=190fe51b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports